import styles from "./Checklist.module.css"
import TagSubtitle from "../TagSubtitle";
import { CircleCheckBig, CircleX, Eye } from 'lucide-react';

function Checklist({ thisChecklist, openModal }) {
    let valueItens = thisChecklist.itens.filter(item => item.problema === true).length
    let assinado = thisChecklist.assinaturas.filter(ass => ass.assinado === true)

    return (
        <div className={styles.container}>
            <div className={styles.containerMain}>
                <div className={styles.infos}>
                    <h2 className={styles.title}>{thisChecklist.car.placa}</h2>
                    <TagSubtitle
                        text={`${thisChecklist.tecnico.name} - ${thisChecklist.data}`}
                        color="#6a7181"
                    />
                </div>

                <div
                    className={styles.status}
                    style={{
                        backgroundColor: thisChecklist.aprovado != true ? "#ef43431a" : "#21c45d1a",
                        color: thisChecklist.aprovado != true ? "#ef4343" : "#21c45d",
                    }}
                >
                    {thisChecklist.aprovado != true ? <p><CircleX size={14} color="#ef4343" />Falha</p> : <p><CircleCheckBig size={14} color="#21c45d" />Ok</p>}
                </div>
            </div>
            <div className={styles.containerInfo}>
                <div>
                    <div className={styles.itens}>
                        {`${thisChecklist.itens.length} itens`}
                    </div>
                    <div
                        className={styles.itens}
                        style={{
                            backgroundColor: valueItens > 0 ? "#ef43431a" : "#21c45d1a",
                            color: valueItens > 0 ? "#ef4343" : "#21c45d",
                        }}
                    >
                        {valueItens > 0 ? `${valueItens} falhas` : `0 falhas`}
                    </div>
                </div>
                {assinado.length > 0 && (
                    <div className={styles.containerAssinatura}>
                        <p>Assinador por: </p>
                        <div className={styles.assinaturas}>
                            <p className={styles.assinatura}>{assinado[0]?.name}</p>
                            <p className={styles.assinatura}>{assinado[1]?.name}</p>
                        </div>
                    </div>
                )}

                <button className={styles.btn} onClick={() => openModal(thisChecklist)}>
                    <Eye size={20} />
                    Ver detalhes
                </button>
            </div>
        </div>
    )
}

export default Checklist